export default {
  route: {
    dashboard: '首页',
    routeSearchVin: 'VIN查询',
    routeVehicleCode: '整车编码查询',
    routeNavigation: '车型导航',
    routeAssemblyNavigation: '四大总成导航',
    routePartsQuery: '零部件查询',
    routeSystem: '系统管理',
    routeSysUser: '用户管理',
    routeSysRole: '角色管理',
    routeSysMenu: '权限管理',
    routeSysEnterprise: '企业信息管理',
    routeSysImg: '照片管理',
    routeSysSupplier: '供应商件标准名称管理',
    routeSysSupplierManage: '供应商件管理',
    routeSysMaintain: '供应商零件名称维护',
    routeSysCategory: '一二级品类关系管理',
    routeSysPartControl: '零部件管控标识管理',
    routeSysControlCategory: '二级品类管控标识管理(含供应商)',
    routeAuxiliary: '辅助功能',
    routePartChangeInfo: '福康变更履历查询',
    routeAccessory: '配件查询',
    routeAtlas: '图册查询',
    routeVehicleAtlas: '整车图册管理',
    routeVinQuery: 'VIN图册查询',
    routeVehicleParts: '整车配件明细查询',
    routeRelationship: '组织权限管理'
  },
  common: {
    commonDelete: '删除',
    commonCancel: '取 消',
    commonConfirm: '确 定',
    commonSearch: '查询',
    commonUpload: '上传',
    commonClear: '重置',
    search: '搜索',
    add: '添加',
    export: '导出',
    publish: '发布',
    common1: '全选',
    common2: '保存',
    common3: '下载'
  },
  tips: {
    vinTips: '请输入17位或后9位VIN号',
    content: '请输入内容',
    select: '请选择'
  },
  login: {
    title: '欢迎登录',
    logIn: '登录',
    username: '账号',
    password: '重置密码',
    any: '随便填',
    userLogIn: '用户名密码'
  },
  cart: {
    routeCart: '购物车',
    viewOrder: '查看订单',
    generateOrder: '生成订单',
    sendOrder: '发送订单',
    partCode: '配件编码',
    partName: '配件名称',
    pcsOrder: '订货量',
    minimum: '最小包装数',
    shoppingNum: '购物车清单单号',
    orderDate: '订单日期',
    startDate: '开始',
    endDate: '结束'
  },
  table: {
    title: '标题',
    type: '类型',
    id: '序号',
    date: '时间',
    status: '状态',
    actions: '操作',
    search: '搜索',
    add: '添加',
    edit: '编辑'
  },
  sysUserList: {
    buildType: '用户类型',
    role: '角色',
    roleName: '角色名称',
    searchValue: '请输入关键字查询',
    code: '账号',
    state: '状态',
    keyWord: '全部',
    job: '岗位',
    userName: '用户姓名',
    sex: '性别',
    phone: '手机号码'
  },
  sysRole: {
    routeSysRole1: '角色名称',
    routeSysRole2: '角色编码',
    routeSysRole3: '门店编码',
    routeSysRole4: '角色备注',
    routeSysRole5: '电话/邮箱',
    routeSysRole6: '创建时间',
    routeSysRole7: '有效期',
    routeSysRole8: '状态'
  },
  sysMenu: {
    routeSysMenu2: '菜单名称',
    routeSysMenu3: '菜单类型',
    routeSysMenu4: '菜单编码',
    routeSysMenu5: '菜单路径',
    routeSysMenu6: '排序'
  },
  sysEnterprise: {
    sysEnterprise1: '企业类型',
    sysEnterprise2: '品牌',
    sysEnterprise3: '企业编码',
    sysEnterprise4: '企业名称',
    sysEnterprise5: '企业地址',
    sysEnterprise6: '联系人姓名',
    sysEnterprise7: '联系人电话',
    sysEnterprise8: '联系人Email',
    sysEnterprise9: '修改时间',
    sysEnterprise10: '修改人',
    sysEnterprise17: '创建时间'
  },
  vinSearch: {
    vehicleCode: '整车编码',
    vinCode: 'vin编码',
    mainBrand: '主品牌',
    subBrand: '子品牌',
    public: '公众号',
    partCode: '零件编号',
    partName: '零件名称'
  },
  partChange: {
    PartChange1: '总成图号',
    PartChange2: '零件图号',
    PartChange3: '照片',
    PartChange4: '变更后零部件编码',
    PartChange5: '变更后零部件名称',
    PartChange6: '变更后零部件启用日期',
    PartChange7: '变更后零部件关系',
    PartChange8: '变更说明'
  },
  accessory: {
    accessory1: '配件图号',
    accessory2: '配件名称',
    accessory3: '供应商编号',
    accessory4: '规格/型号',
    accessory5: '计量单位',
    accessory6: '特征说明',
    accessory7: '上一替代件',
    accessory8: '下一替代件',
    accessory9: '供应商名称'
  },
  vehicleAtlas: {
    vehicleAtlas1: '图册编码',
    vehicleAtlas2: '图册版本号',
    vehicleAtlas3: '图册名称',
    vehicleAtlas4: '图册下载',
    vehicleAtlas5: '整车图册下载',
    vehicleAtlas6: '子组图册下载',
    vehicleAtlas7: '管理内容',
    vehicleAtlas8: '整车版本',
    vehicleAtlas9: '数量',
    vehicleAtlas10: '照片导出'
  },
  supplier: {
    supplier1: '二级品类代码',
    supplier2: '二级品类名称',
    supplier3: '二级品类英文名称',
    supplier4: '创建人',
    supplier5: '最后修改人',
    supplier6: '最后修改日期',
    supplier7: '照片名称',
    supplier8: '修改时间',
    supplier9: '零部件图号',
    supplier10: '管控标识',
    supplier11: '模板下载'
  },
  sysImg: {
    sysImg1: '照片大小',
    sysImg2: '照片缩略图',
    sysImg3: '照片上传',
    sysImg4: '同步'
  },
  partControl: {
    partControl1: '零部件图号',
    partControl2: '零部件名称',
    partControl3: '供应商代码'
  },
  excel: {
    export: '导出',
    export2: '导入',
    selectedExport: '导出已选择项'
  }
}
